<template>
	<div class="jumbotron d-flex min-vh-100" :class="isAligned ? 'align-items-center' : ''">
		<div class="container text-center">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DefaultComponent',
	props: {
		isAligned: {
			type: Boolean,
			default: true
		}
	}
};
</script>

<style scoped>
.jumbotron {
	background-color: #f2f6fe !important;
	margin-bottom: 0 !important;
}
</style>
